import { supabasePublishableKey, supabaseUrl } from './supabase'

export function supabaseFunctionUrl(name: string, query?: Record<string, string>) {
  const url = new URL(`${supabaseUrl.replace(/\/$/, '')}/functions/v1/${name}`)
  if (query) {
    for (const [key, value] of Object.entries(query)) {
      url.searchParams.set(key, value)
    }
  }
  return url.toString()
}

export function callSupabaseFunction(
  name: string,
  init: RequestInit = {},
  query?: Record<string, string>,
) {
  const headers = new Headers(init.headers)
  headers.set('apikey', supabasePublishableKey)
  if (!headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${supabasePublishableKey}`)
  }

  return fetch(supabaseFunctionUrl(name, query), {
    ...init,
    headers,
  })
}

export function callAuthedSupabaseFunction(
  name: string,
  accessToken: string,
  init: RequestInit = {},
  query?: Record<string, string>,
) {
  const headers = new Headers(init.headers)
  headers.set('Authorization', `Bearer ${accessToken}`)
  return callSupabaseFunction(name, { ...init, headers }, query)
}
